/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Draft_NoticeInputs */

const en_legal_draft_notice = /** @type {(inputs: Legal_Draft_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our company details are still being added to this document.`)
};

const pl_legal_draft_notice = /** @type {(inputs: Legal_Draft_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane naszej firmy są jeszcze uzupełniane w tym dokumencie.`)
};

/**
* | output |
* | --- |
* | "Our company details are still being added to this document." |
*
* @param {Legal_Draft_NoticeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_draft_notice = /** @type {((inputs?: Legal_Draft_NoticeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Draft_NoticeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_draft_notice(inputs)
	return en_legal_draft_notice(inputs)
});